// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_1jKw6","dropdown":"tbnOk","dropdownContent":"_3sxKR","triggerList":"_1Cy8Q","filterTrigger":"_2mrUm"};